import { render, staticRenderFns } from "./RequiredNutrientContent.vue?vue&type=template&id=741478bf&scoped=true&"
import script from "./RequiredNutrientContent.vue?vue&type=script&lang=js&"
export * from "./RequiredNutrientContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "741478bf",
  null
  
)

export default component.exports